module.exports = __webpack_public_path__ + "static/media/notification-alert.7fe071af.svg";